import React, { useEffect, useState } from 'react';
import { Menu, X, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
interface NavbarProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Navbar({
  currentPage,
  onNavigate
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    id: 'home',
    label: 'Startseite'
  }, {
    id: 'leistungen',
    label: 'Leistungen'
  }, {
    id: 'rechner',
    label: 'Rechner'
  }, {
    id: 'app',
    label: 'App'
  }, {
    id: 'beratung',
    label: 'Beratung'
  }, {
    id: 'ueber-uns',
    label: 'Über uns'
  }];
  const handleNavClick = (pageId: string) => {
    onNavigate(pageId);
    setIsOpen(false);
  };
  return <nav className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm' : 'bg-white border-b border-transparent'}`} data-id="element-222">
      <div className="container mx-auto px-4 md:px-6" data-id="element-223">
        <div className="flex h-20 items-center justify-between" data-id="element-224">
          <div className="flex items-center gap-2.5 cursor-pointer group" onClick={() => handleNavClick('home')} data-id="element-225">
            <div className="relative" data-id="element-226">
              <div className="absolute inset-0 bg-blue-500 blur-lg opacity-20 rounded-full group-hover:opacity-40 transition-opacity" data-id="element-227"></div>
              <ShieldCheck className="relative h-9 w-9 text-blue-600" data-id="element-228" />
            </div>
            <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700" data-id="element-229">
              SmartProtect<span className="text-blue-600" data-id="element-230">24</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8" data-id="element-231">
            {navItems.map(item => <button key={item.id} onClick={() => handleNavClick(item.id)} className={`text-sm font-medium transition-all hover:text-blue-600 relative group ${currentPage === item.id ? 'text-blue-600' : 'text-slate-600'}`} data-id="element-232">
                {item.label}
                <span className={`absolute -bottom-1 left-0 h-0.5 bg-blue-600 transition-all duration-300 ${currentPage === item.id ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-233"></span>
              </button>)}
          </div>

          <div className="hidden lg:flex items-center gap-4" data-id="element-234">
            <button onClick={() => handleNavClick('faq')} className={`text-sm font-medium transition-colors hover:text-blue-600 ${currentPage === 'faq' ? 'text-blue-600' : 'text-slate-600'}`} data-id="element-235">
              FAQ
            </button>
            <Button onClick={() => handleNavClick('kontakt')} variant="ghost" className="font-medium" data-id="element-236">
              Kontakt
            </Button>
            <Button onClick={() => handleNavClick('app')} variant="premium" className="shadow-lg shadow-blue-500/20" data-id="element-237">
              App nutzen
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden" data-id="element-238">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center rounded-md p-2 text-slate-700 hover:bg-slate-100 hover:text-slate-900 focus:outline-none" data-id="element-239">
              {isOpen ? <X className="h-6 w-6" data-id="element-240" /> : <Menu className="h-6 w-6" data-id="element-241" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur-xl absolute w-full shadow-xl" data-id="element-242">
          <div className="space-y-1 px-4 py-6" data-id="element-243">
            {navItems.map(item => <button key={item.id} onClick={() => handleNavClick(item.id)} className={`block w-full text-left rounded-lg px-4 py-3 text-base font-medium transition-colors ${currentPage === item.id ? 'bg-blue-50 text-blue-600' : 'text-slate-700 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-244">
                {item.label}
              </button>)}
            <div className="mt-6 pt-6 border-t border-slate-100 flex flex-col gap-3" data-id="element-245">
              <Button variant="ghost" className="w-full justify-start" onClick={() => handleNavClick('faq')} data-id="element-246">
                FAQ
              </Button>
              <Button variant="outline" className="w-full" onClick={() => handleNavClick('kontakt')} data-id="element-247">
                Kontakt
              </Button>
              <Button variant="premium" className="w-full" onClick={() => handleNavClick('app')} data-id="element-248">
                App kostenlos nutzen
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}